import '@babel/polyfill/dist/polyfill.min'
import React from 'react'
import ReactDOM from 'react-dom'
import {HashRouter} from "react-router-dom";
import { MigrationRouter } from "@eforms/forms-common-ui";

// Prepare to work with WebSDK: http://websdk.rbsgrp.net/
import '@zambezi/sdk-themes/zb-natwest-group-standard/icons'
import '@zambezi/sdk-themes/zb-natwest-group-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-natwest-nonpersonal-standard/icons'
import '@zambezi/sdk-themes/zb-natwest-nonpersonal-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-rbs-nonpersonal-standard/icons'
import '@zambezi/sdk-themes/zb-rbs-nonpersonal-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-rbsi-standard/icons'
import '@zambezi/sdk-themes/zb-rbsi-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-isleofmanbank-standard/icons'
import '@zambezi/sdk-themes/zb-isleofmanbank-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-lombard-standard/icons'
import '@zambezi/sdk-themes/zb-lombard-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-ulsterbank-standard/icons'
import '@zambezi/sdk-themes/zb-ulsterbank-standard/theme.min.css'
import '@zambezi/sdk-themes/zb-natwesti-standard/icons'
import '@zambezi/sdk-themes/zb-natwesti-standard/theme.min.css'

import '@zambezi/formidable-components/dist/formidable-components.min.css'

import '@zambezi/sdk-themes/zb-champion-standard/icons';
import '@zambezi/sdk-themes/zb-champion-standard/theme.min.css';

// Load application specific parts
import './index.css'
import App from './App'
import store from './redux/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker'

import './WebSDKResponsiveLayout.css';

const app = (
    <Provider store={store}>
        <HashRouter>
            <MigrationRouter appType="external">
                <App/>
            </MigrationRouter>
        </HashRouter>
    </Provider>
);


// The following code picks Content security Policy from congiguration 
// and updates that for the app franchise wise.
let csp_tag = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
csp_tag.setAttribute('content',window.environmentConfig.contentSecurityPolicy)

ReactDOM.render(app, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
